import { t } from 'i18next';
import React from 'react';

const Carousel = () => {
  const carouselItems = [
    {
      id: 1,
      image: "img/carousel-1.png",
      active: true
    },
  ];

  return (
    <div className="container-fluid px-0 mb-5">
      <div id="header-carousel" className="carousel slide carousel-fade" data-bs-ride="carousel">
        <div className="carousel-inner">
          {carouselItems.map((item, index) => (
            <div key={item.id} className={`carousel-item ${item.active ? 'active' : ''}`}>
              <img className="w-100" src={item.image} alt="Image" />
              <div className="carousel-caption">
                <div className="container">
                  <div className="row justify-content-center">
                    <div className="col-lg-7 text-center">
                      <p className="fs-4 text-white animated zoomIn">{t('welcome_to')} <strong className="text-dark">{t('atilal_company')}</strong></p>
                      <h1 className="text-dark mb-4 animated zoomIn">{t('trusted_partner_modern')}</h1>
                      <a href="" className="btn btn-light rounded-pill py-3 px-5 animated zoomIn">{t('explore_more')}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Carousel;